import { lazy, Suspense } from "react";

import {
	BrowserRouter as Router,
	Navigate,
	Route,
	Routes,
} from "react-router-dom";

import "./App.css";
import Home from "./components/home/Home.jsx";
import LoadingState from "./components/common/LoadingState.jsx";

const Contact = lazy(() => import("./components/contact/Contact.jsx"));
const About = lazy(() => import("./components/About/About.jsx"));
const Prom = lazy(() => import("./components/pages/Prom.jsx"));
const ViewProduct = lazy(() => import("./components/pages/ViewProduct.jsx"));
const SizeChart = lazy(() => import("./components/SizeChart/SizeChart.jsx"));

function RouteLoading() {
	return (
		<div className="min-h-screen bg-white pt-24">
			<LoadingState
				label="Loading Azure page..."
				description="Please wait a moment."
				minHeight={500}
			/>
		</div>
	);
}

function App() {
	return (
		<Router>
			<Suspense fallback={<RouteLoading />}>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/contact" element={<Contact />} />
					<Route path="/about" element={<About />} />

					<Route
						path="/prom/:year"
						element={<Prom category="Prom" />}
					/>

					<Route
						path="/bridal/:year"
						element={<Prom category="Bridal" />}
					/>

					<Route
						path="/evening/:year"
						element={<Prom category="Evening" />}
					/>

					<Route
						path="/product/id/:style"
						element={<ViewProduct />}
					/>

					<Route
						path="/size-chart/:category"
						element={<SizeChart />}
					/>

					<Route path="*" element={<Navigate to="/" replace />} />
				</Routes>
			</Suspense>
		</Router>
	);
}

export default App;
